import { useTrans } from '@/shared/hooks/useTranslation';
import { Button } from '@/view/shared/Button';
import { Modal } from '@/view/shared/Modal';
import { useSkipOnboardingViewModel } from '@/viewmodel/features/onboarding';
import type React from 'react';

interface SkipOnboardingModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}

export function SkipOnboardingModal({
  isOpen,
  onClose,
}: SkipOnboardingModalProps): React.JSX.Element | null {
  const { t } = useTrans();
  const { confirm, isSkipping } = useSkipOnboardingViewModel(onClose);

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={(open) => {
        if (!open) onClose();
      }}
      title={t('onboarding.dismiss.title')}
      size="sm"
    >
      <div className="flex flex-col gap-6 pb-4">
        <p className="text-sm text-muted-foreground">{t('onboarding.dismiss.description')}</p>
        <div className="flex justify-end gap-3">
          <Button variant="ghost" onClick={onClose} disabled={isSkipping}>
            {t('onboarding.dismiss.cancel')}
          </Button>
          <Button variant="primary" onClick={confirm} isLoading={isSkipping}>
            {t('onboarding.dismiss.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
